import { ServerService } from '../../../ts/services/ServerService';
import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { IDetailFetcher } from '../../../ts/fetchers/IDetailFetcher';
import { GetDetailRequest } from '../../../ts/ServerApi/requests/GetDetailRequest';
import { ResultHelper } from '../../../ts/helpers/ResultHelper';
import { ServiceLocator } from '../../../app/ServiceLocator';

export class WebClientDetailFetcher<TResource, TRequestResult> implements IDetailFetcher<TResource> {

  constructor(
    private requestMethod: string,
    private resultMapper: (result: TRequestResult) => TResource
  ) { }

  public fetchById(id: string): ng.IPromise<TResource> {
    const $q = ServiceLocator.get<ng.IQService>('$q');
    return ServiceLocator.get<ServerService>('ServerService')
      .sendRequest(new GetDetailRequest<TRequestResult>(this.requestMethod, id))
      .then(ResultHelper.rejectResultOnError($q))
      .then<TResource>(
        (result: TRequestResult) => $q.when(this.resultMapper(result)),
        (result: IResult) => $q.reject(result.errors && result.errors[0] && result.errors[0].code)
      );
  }

}
